import { render, staticRenderFns } from "./manual_create_details.vue?vue&type=template&id=e82ed608&scoped=true"
import script from "./manual_create_details.vue?vue&type=script&lang=js"
export * from "./manual_create_details.vue?vue&type=script&lang=js"
import style0 from "./manual_create_details.vue?vue&type=style&index=0&id=e82ed608&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82ed608",
  null
  
)

export default component.exports